
import { createSelector } from 'reselect';
import EditorTabTypes from './EditorTabTypes';

/**
 * Functions in this file are site-editor specific.
 * They used to live under `nucleus-site-editor/src/redux/modules/editor`.
 */

/**
 * Gets the id of the page currently selected by the user.
 */
export function getSelectedPageId(state) {
  return state.pageId;
}

/**
 * Gets the id of the item currently selected by the user.
 */
export function getSelectedItemId(state) {
  return state.editorPanelTabNavigation[EditorTabTypes.BUILD].selectedItemId;
}

/**
 * Gets the context editor navigation stack information.
 */
export const getSelectedEditorPanelTab = createSelector(
  (state) => state.selectedEditorPanelTab,
  (state) => state.editorPanelTabNavigation,
  (selectedEditorPanelTab, editorPanelTabNavigation) => {
    return editorPanelTabNavigation[selectedEditorPanelTab];
  }
);
